import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import {
  FluidSecondsToDurationOptionsInterface,
  FluidSecondsToDurationOptions,
} from 'app/modules/global/services/fluid-duration.service';
import { FluidSecondsToDurationPipe } from '../../../global/pipes/fluidDuration.pipe';

@Component({
  selector: 'app-duration',
  templateUrl: './duration.component.html',
  imports: [FluidSecondsToDurationPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DurationComponent {
  time = input.required<number>(); // seconds
  options = input<FluidSecondsToDurationOptionsInterface>();

  mergedOptions = computed(() => {
    return new FluidSecondsToDurationOptions(this.options());
  });
}
